import ApiCore from './api-core'

export default class apiBase extends ApiCore {
  getAll (filter, showProgress) {
    return this._request({
      action: 'report',
      method: 'GET',
      params: filter,
      showProgress
    })
  }





  create (model, showProgress) {
    return this._request({
      method: 'POST',
      action: 'create',
      body: model,
      showProgress
    })
  }

  update (id, model, showProgress) {
    return this._request({
      action: this._urlencode(id),
      method: 'PUT',
      body: model,
      showProgress
    })
  }

  getById (id, showProgress) {
    return this._request({
      action: this._urlencode(id),
      method: 'GET',
      showProgress
    })
  }

  delete (id, showProgress) {
    return this._request({
      action: this._urlencode(id),
      method: 'DELETE',
      showProgress
    })
  }

  count (filter, showProgress) {
    return this._request({
      action: 'count',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
  getlist (filter, showProgress) {
    return this._request({
      params: filter ,
      action: 'list',
      method: 'GET',
      showProgress
    })
  }
  enable (Id,showProgress) {
    return this._request({
      action: `${this._urlencode(Id)}/enable`,
      method: 'PATCH',
      showProgress
    })
  }
  disable (Id,showProgress) {
    return this._request({
      action: `${this._urlencode(Id)}/disable`,
      method: 'PATCH',
      showProgress
    })
  }
}
